import { supabase } from "@/integrations/supabase/client";

export type ConversionEventType =
  | "paywall_viewed"
  | "upgrade_initiated"
  | "upgrade_completed"
  | "returning_banner_clicked"
  | "cancellation_initiated"
  | "signup_completed";

export async function trackConversion(
  eventType: ConversionEventType,
  metadata?: Record<string, unknown>
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    const { data: profile } = await supabase
      .from("profiles")
      .select("business_id")
      .eq("user_id", user.id)
      .limit(1)
      .maybeSingle();
    await supabase.from("conversion_events").insert({
      user_id: user.id,
      business_id: (profile as { business_id?: string } | null)?.business_id ?? null,
      event_type: eventType,
      metadata: metadata ?? {},
    });
  } catch {
    // non-blocking
  }
}
